import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody, Table } from "reactstrap";
import { phoneNumberShowFormat } from "helpers/GeneralHelper";

const mapCandidateRows = (rows = []) =>
    (Array.isArray(rows) ? rows : []).map((item = {}, index) => ({
        id:
            item?.candidateId ??
            item?.id ??
            item?._id ??
            `${item?.clientId || "client"}-${index}`,
        candidate: item?.candidateFullName ?? item?.candidate ?? item?.name ?? "",
        client: item?.companyName ?? item?.clientName ?? item?.client ?? "",
        email: item?.candidateEmail ?? item?.email ?? "",
        phone: phoneNumberShowFormat(
            item?.candidatePhone ?? item?.phone ?? item?.phoneNumber ?? ""
        ),
    }));

const ClosureReportCandidatesModal = ({
    isOpen,
    onClose,
    userName = "",
    jobCategoryName = "",
    jobName = "",
    candidates = [],
}) => {
    const candidateRows = useMemo(
        () => mapCandidateRows(candidates),
        [candidates]
    );

    const modalTitle = useMemo(() => {
        const parts = [userName, jobCategoryName, jobName]
            .map((value) => String(value || "").trim())
            .filter(Boolean);
        return parts.length ? parts.join(" > ") : "Closure Candidates";
    }, [userName, jobCategoryName, jobName]);

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            backdrop="static"
            centered
            size="lg"
            className="closure-report-candidates-modal modal-full-height"
        >
            <ModalBody className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="fw-bold mb-0">{modalTitle}</h5>
                    <Button close type="button" onClick={onClose} />
                </div>

                <div className="table-responsive">
                    <Table bordered className="align-middle mb-0">
                        <thead>
                            <tr>
                                <th>Candidate</th>
                                <th>Client</th>
                                <th>Email</th>
                                <th>Phone</th>
                            </tr>
                        </thead>
                        <tbody>
                            {candidateRows.length ? (
                                candidateRows.map((row) => (
                                    <tr key={row.id}>
                                        <td>{row.candidate || "—"}</td>
                                        <td>{row.client || "—"}</td>
                                        <td>{row.email || "—"}</td>
                                        <td>{row.phone || "—"}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4} className="text-center text-muted py-4">
                                        No candidates found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </ModalBody>
        </Modal>
    );
};

ClosureReportCandidatesModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    userName: PropTypes.string,
    jobCategoryName: PropTypes.string,
    jobName: PropTypes.string,
    candidates: PropTypes.array,
};

export default ClosureReportCandidatesModal;
